/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  // Add custom code below this line

  var cartCount = 0;
var currentVariant;
  document.addEventListener('theme:variant:change', (event) => {    
    let variant = event.detail.variant;
    currentVariant = variant.id;
    console.log('variant', variant);
    if (document.body.classList.contains('template-product')) {
      if(document.querySelector('#stickyATC')) {
        document.querySelector('#stickyATC input[name="id"]').value = variant.id;
        document.querySelector('#stickyATC span[data-product-price]').innerText = document.querySelector('.product-single__details .product__form .btn--submit span[data-product-price]').innerText;
        document.querySelector('#stickyATC span[data-add-to-cart-text]').innerText = document.querySelector('.product-single__details .product__form .btn--submit span[data-add-to-cart-text]').innerText;
      }
      document.querySelectorAll('.sky-product-service').forEach(item=>{
        item.innerText = variant.option1;
      });
      document.querySelectorAll('.sky-product-session').forEach(item=>{
        item.innerText = variant.option2;
      });      
      document.querySelectorAll('[data-view-cart]')?.forEach(selector => {
        selector.setAttribute('data-add-to-cart', '');
        selector.setAttribute('type', 'submit');
        if(selector.querySelector('[data-add-to-cart-text]')) selector.querySelector('[data-add-to-cart-text]').innerText = 'Add to Cart';
        if(selector.querySelector('.btn__text')) selector.querySelector('.btn__text').innerText = 'Add to Cart';
        selector.removeAttribute('data-view-cart');
        selector.classList.remove('btn--view');
      });

      // priceChange
   setTimeout(function() {
    var getUrl = document.querySelector('.hidden_master').dataset.url;
    var sectionId = document.querySelector('.hidden_master').dataset.section;
    var finalUrl = window.location.href + '&section_id=' + sectionId;
    
    fetch(finalUrl)
        .then((response) => response.text())
        .then((responseText) => {
            var parser = new DOMParser();
            var doc = parser.parseFromString(responseText, 'text/html');
            
            // Find all the '.varPrice' elements in the fetched HTML response
            var productPrices = $(doc).find('.varPrice');
            
            // Find all the '.varPrice' elements in the current document
            var currentVarPrices = document.querySelectorAll('.varPrice');
            
            // Check if there are corresponding elements to replace HTML with
            if (productPrices.length > 0 && currentVarPrices.length > 0) {
                // Loop through both productPrices and currentVarPrices
                productPrices.each(function(index, element) {
                    if (currentVarPrices[index]) {
                        var productPriceHTML = $(element).html();
                        // Replace the HTML content of the corresponding current varPrice element
                        currentVarPrices[index].innerHTML = productPriceHTML;
                    }
                });
            }
        })
        .catch((error) => console.error('Error fetching data:', error));
}, 1000);



    }
  });

  const getCartCount = () => {
    fetch('/cart.js')
    .then(response => {
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return response.json();
    })
    .then(cart => {
        // console.log('cart', cart);
        document.querySelectorAll('.cart-count').forEach(item=>{
          if(cart.item_count == 0) {
            item.innerText = '';
          } else {
            item.innerText = cart.item_count;
          }
        });
    })
    .catch(error => {
        console.error('There was a problem with the fetch operation:', error);
    });
  }

  document.addEventListener('theme:cart:update', (event) => {
    getCartCount();
  });

  document.addEventListener('theme:cart:added', (event) => {
    getCartCount();
  });
  
  document.addEventListener('theme:cart:loaded', (event) => {
    setTimeout(function() {
      getCartCount();
    }, 500);
  });

  document.querySelectorAll('[data-item-remove]')?.forEach(btn => {
    btn.addEventListener('click', (event) => {
      setTimeout(function() {
        getCartCount();
      }, 500);
    });
  });
  
  document.addEventListener('theme:cart:add', (event) => {
    let selector = event.detail.selector;
    selector = selector.closest('button') ? selector.closest('button'): selector;
    selector.classList.add('btn--view');
    document.addEventListener('theme:cart:added', (event) => {
      selector.setAttribute('data-view-cart', '');
      
      selector.setAttribute('type', 'button');
      if(selector.querySelector('[data-add-to-cart-text]')) selector.querySelector('[data-add-to-cart-text]').innerText = 'View In Cart';
      if(selector.querySelector('.btn__text')) selector.querySelector('.btn__text').innerText = 'View In Cart';
      selector.removeAttribute('data-add-to-cart');      

      // Attach the click event listener after setting the attributes
      selector.addEventListener('click', (event) => {
          document.querySelector('.cart__toggle').click();
      });
    });
  });
  
  jQuery(document).on('click', '.cart__item__remove', function() {
    // Get the variant ID from the clicked item's data-id attribute
    let variantID = jQuery(this).data('id').split(':')[0];
    console.log('Variant ID:', variantID);
  
    // Cache selectors to optimize performance
    const $productSubmitButtons = jQuery('.product__submit__buttons');
    const $quickBuyButtons = jQuery('.product-grid-item__quick-buy .btn--view');
  
    if (variantID == currentVariant) {
      setTimeout(function() {
        // Update buttons in the product submit section
        $productSubmitButtons.find('button').removeClass('btn--view');
        $productSubmitButtons.find('[data-add-to-cart-text]').html('Add to cart');
      }, 1000);
    }
  
    setTimeout(function() {
      // Update buttons in the product grid section
      $quickBuyButtons.find('.btn__text').html('Add to cart');
      $quickBuyButtons.removeClass('btn--view');
    }, 1000);
  });
  
  // Prevent default action on quick-buy buttons when clicked
  jQuery(document).on('click', '.product-grid-item__quick-buy .btn--view', function(evt) {
    evt.preventDefault();
  });

                             

  // document.querySelector('.cart__toggle').click();


  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();